import React from "react";
import * as properties from '../../elementsPropertiesItems';
// import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';

const FontStyle = (props)=>{
    const {path,keyParam,elementData} = props;
    let fontStyleValue = isSet(elementData,null)!==null?isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'normal':'normal';

    const changeHandler = (e) => {
        const {value} = e.target;        
        props.changeHandler(path,keyParam,value)
    }

    return(
        <div className="w-100">
     		<select className="form-control input-border-bottom1" onChange={e=>changeHandler(e)}>
                {
                    properties.FontStyleTypes.map((item,ind)=>{
                        let isSelected = '';
                        if(item.value === fontStyleValue){
                           isSelected = 'selected';
                        }
                        return(
                            <option selected={isSelected} value={item.value}> {item.label} </option>    
                        )
                    })
                }        		
     		</select>
  		</div>
    )
}

FontStyle.defaultProps = {
    fontStyleValue: 'normal',    
};

export default FontStyle;